import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    [
      _c(VCardTitle, [
        _vm._v(
          _vm._s(
            _vm.isEditMode
              ? "Edit Production Schedule"
              : "New Production Schedule"
          )
        ),
      ]),
      _c(VCardSubtitle, [
        _vm._v(
          " " + _vm._s(_vm.product ? _vm.product.name : "Product N/A") + " "
        ),
      ]),
      _c(
        VCardText,
        [
          _vm.customers
            ? _c(VAutocomplete, {
                staticStyle: { "z-index": "100" },
                attrs: {
                  clearable: "",
                  label: "Customer",
                  placeholder: "Optional",
                  items: _vm.customers,
                  "item-text": "name",
                  "item-value": "id",
                },
                model: {
                  value: _vm.production.customerId,
                  callback: function ($$v) {
                    _vm.$set(_vm.production, "customerId", $$v)
                  },
                  expression: "production.customerId",
                },
              })
            : _vm._e(),
          _vm.productionLines
            ? _c(VAutocomplete, {
                staticStyle: { "z-index": "100" },
                attrs: {
                  clearable: "",
                  label: "Production Line",
                  placeholder: "Optional",
                  items: _vm.productionLines,
                  "item-text": "name",
                  "item-value": "id",
                },
                model: {
                  value: _vm.production.productionLineId,
                  callback: function ($$v) {
                    _vm.$set(_vm.production, "productionLineId", $$v)
                  },
                  expression: "production.productionLineId",
                },
              })
            : _vm._e(),
          _c(VTextField, {
            attrs: { label: "Quantity", type: "number" },
            model: {
              value: _vm.production.quantity,
              callback: function ($$v) {
                _vm.$set(_vm.production, "quantity", $$v)
              },
              expression: "production.quantity",
            },
          }),
          _c("date-picker", {
            attrs: {
              label: _vm.$vuetify.lang.t("$vuetify.base.startDate"),
              defaultNowOnNull: false,
            },
            model: {
              value: _vm.production.start,
              callback: function ($$v) {
                _vm.$set(_vm.production, "start", $$v)
              },
              expression: "production.start",
            },
          }),
          _c("date-picker", {
            attrs: {
              label: _vm.$vuetify.lang.t("$vuetify.base.endDate"),
              defaultNowOnNull: false,
            },
            model: {
              value: _vm.production.end,
              callback: function ($$v) {
                _vm.$set(_vm.production, "end", $$v)
              },
              expression: "production.end",
            },
          }),
          _c(VTextarea, {
            attrs: {
              label: "Memo",
              placeholder: "Optional",
              rows: 2,
              "auto-grow": "",
              outlined: "",
            },
            model: {
              value: _vm.production.memo,
              callback: function ($$v) {
                _vm.$set(_vm.production, "memo", $$v)
              },
              expression: "production.memo",
            },
          }),
        ],
        1
      ),
      _c(
        VCardActions,
        { staticClass: "d-flex justify-space-between" },
        [
          _c(
            "div",
            [
              _c(
                VBtn,
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" " + _vm._s(_vm.isEditMode ? "Update" : "Save"))]
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-2",
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
            ],
            1
          ),
          _vm.isEditMode
            ? _c(
                VBtn,
                { attrs: { color: "warning" }, on: { click: _vm.remove } },
                [_vm._v(" Delete ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }